/*
 * Copyright (c) 2024, King Living
 * Account page configuration constants
 */

/** Delay (ms) before scrolling to hash target on profile page */
export const HASH_SCROLL_DELAY = 100;

/**
 * Custom event: user chose Personal details while already on /account/profile with no hash.
 * Profile page listens to re-run smooth scroll when React Router does not change location.
 */
export const ACCOUNT_PROFILE_SCROLL_TOP_EVENT = 'account-profile:scroll-top';

/** Desktop sidebar width */
export const ACCOUNT_SIDEBAR_WIDTH = '234px';

/** Chakra `Grid` gap on account container at lg (`gap={{ lg: 24 }}` → 96px). */
export const ACCOUNT_LANDING_GRID_GAP_LG = '96px';

/** Break out of main column to full account grid track (sidebar + gap + content). */
export const ACCOUNT_LANDING_GET_INSPIRED_BREAKOUT_LG = `calc(100% + ${ACCOUNT_SIDEBAR_WIDTH} + ${ACCOUNT_LANDING_GRID_GAP_LG})`;

export const ACCOUNT_LANDING_GET_INSPIRED_OFFSET_LG = `calc(-1 * (${ACCOUNT_SIDEBAR_WIDTH} + ${ACCOUNT_LANDING_GRID_GAP_LG}))`;

/** Contentful `layoutContext` for My Account overview sections (ProductTiles, BlogRelatedArticles). */
export const ACCOUNT_LANDING_LAYOUT_CONTEXT = 'account-landing';

/** Max products in the My Account "Suggested for you" carousel (FSD ACCOUNT-02 / KINDW-1763). */
export const ACCOUNT_LANDING_SUGGESTED_PRODUCT_LIMIT = 3;

/** Max content width for account container */
export const ACCOUNT_MAX_CONTENT_WIDTH = '1440px';

/** Product range tile width on account landing suggested carousel — desktop (Figma 5759:50665). */
export const ACCOUNT_LANDING_PRODUCT_TILE_WIDTH_PX = 317;

/** Mobile tile width in suggested carousel (Figma 5759:56824). */
export const ACCOUNT_LANDING_PRODUCT_TILE_MOBILE_WIDTH_PX = 280;

/** Carousel gap — mobile 3px / desktop 4px (Figma 5759:56823 / 5759:50664). */
export const ACCOUNT_LANDING_SUGGESTED_CAROUSEL_GAP_MOBILE = 3;
export const ACCOUNT_LANDING_SUGGESTED_CAROUSEL_GAP_DESKTOP = 4;

/** Desktop slides visible in suggested carousel. */
export const ACCOUNT_LANDING_SUGGESTED_CAROUSEL_SLIDES_DESKTOP = 3;

/** Mobile slides visible (peek) — ~280px tile at 375px viewport (355px swiper × 20px inset). */
export const ACCOUNT_LANDING_SUGGESTED_CAROUSEL_SLIDES_MOBILE = 1.265;

/** Gap between suggested heading and carousel on account landing (32px). */
export const ACCOUNT_LANDING_SUGGESTED_SECTION_GAP = 8;

/** Orders shown before "Show older orders" expand (FSD ACCHIST-04) */
export const ORDER_HISTORY_INITIAL_VISIBLE_COUNT = 6;

/** localStorage key for persisting checkout marketing opt-in across basket merges and passwordless login redirects */
export const CHECKOUT_MARKETING_OPT_IN_KEY = 'king_checkout_marketing_opt_in';
